import React, { Component } from 'react'
import $ from 'jquery'
import * as Common from '../CommonControlls/CommonJs'
import MainLayout from '../CommonControlls/MainLayout'
import Topmenu from '../CommonControlls/Topmenubar'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import AlertModal from '../CommonControlls/AlertModal'
import { SyncConfig } from '../OfflineDb/ConfigDataSync'
import DropDown from '../CommonControlls/DropdownRendrer'

const mapStateToProps = (store) => {
  return store
}

const mapDispatchToProps = (dispatch) => {
  return {
    ShowAlert: (Settings) => {
      dispatch({ type: 'UpdateAlert', payload: Settings })
    },
    ShowLoader: (Isloading) => {
      dispatch({ type: 'UpdateLoader', payload: Isloading })
    },
  }
}

class Dispute_Add extends Component {
  constructor(props) {
    super(props)
    this.state = {
      Id: 0,

      alertModalData: {
        title: '',
        message: '',
        First_Callback: () => {},
        Second_Callback: () => {},
        type: 1,
      },

      ProvinceLoader: false,
      Provincelist: [],
      ProvinceId: 0,

      DistrictLoader: false,
      Districtlist: [],
      FilteredDistrictlist: [],
      DistrictId: 0,

      TehsilLoader: false,
      Tehsillist: [],
      FilteredTehsillist: [],
      TehsilId: 0,

      AssignmentList: [],
      FilteredAssignments: [],
      AssignmentId: 0,

      PatientSamples: [],
      PatientSampleId: 0,

      RiderList: [],
      RiderId: 0,

      deleted: false,
    }
  }

  HandleAutoSuggestValChange = (fieldId, value) => {
    this.setState({ [fieldId]: value }, () => {
      if (fieldId === 'ProvinceId') {
        const TempArr = this.state.Districtlist
        const filteredArr = TempArr.filter(function (obj) {
          return obj.provinceId === value
        })
        this.setState({
          FilteredDistrictlist: filteredArr,
        })
      }

      if (fieldId === 'DistrictId') {
        const TempArr = this.state.Tehsillist
        const filteredArr = TempArr.filter(function (obj) {
          return obj.districtId === value
        })

        this.SelectAssignments()
        this.SelectPatientSamples()

        this.setState({
          FilteredTehsillist: filteredArr,
        })
      }
      if (fieldId === 'TehsilId') {
        this.SelectRiders()
      }
    })
  }

  render() {
    return (
      <div>
        <AlertModal {...this.state.alertModalData} />
        <MainLayout />
        <div id="right-panel" class="right-panel">
          <Topmenu
            PageTitle={this.state.Id === 0 ? 'Add Dispute' : 'Edit Dispute'}
            isShowAddBtn={false}
          />
          <div class="content">
            {/*
                            <div class="PageHeader_Container">
                                <h2>{this.state.Id==0?"Add BHU & RHC":"Edit BHU & RHC"}</h2>
                            </div> */}

            <div class="card col-lg-8 col-md-8 col-sm-12 col-xs-12">
              <div class="card-body row">
                <div class="">
                  <form onSubmit={this.SubmitForm} novalidate>
                    <div class="row">
                      {/*<div class="formInput_Container col-lg-6 col-md-6 col-sm-12 col-xs-12">*/}
                      {/*    <label for=""><span style={{color: "red"}}>* </span>Name</label>*/}
                      {/*    <input autocomplete="off" type="text" class="form-control" id="HCFName"*/}
                      {/*           placeholder="Enter Name" required/>*/}
                      {/*</div>*/}

                      {/*<div class="formInput_Container col-lg-6 col-md-6 col-sm-12 col-xs-12">*/}
                      {/*    <label for="">Contact</label>*/}
                      {/*    <input autocomplete="off" pattern="[0][0-9]{10}" type="text"*/}
                      {/*           class="form-control" id="Contact"*/}
                      {/*           placeholder="Enter contact - 03123456789"/>*/}
                      {/*</div>*/}

                      <div class="formInput_Container col-lg-6 col-md-6 col-sm-12 col-xs-12">
                        <label for="">
                          <span style={{ color: 'red' }}>* </span>Province
                        </label>
                        <DropDown
                          multi={false}
                          dropdownRenderer={false}
                          create={false}
                          onChange={this.HandleAutoSuggestValChange}
                          Type="ProvinceId"
                          options={this.state.Provincelist}
                          val={this.state.ProvinceId}
                          addPlaceholder=""
                          disabled={false}
                          loading={this.state.ProvinceLoader}
                          searchBy="name"
                          labelField="name"
                          valueField="id"
                          contentRenderer={false}
                          placeholder="Select"
                        />
                      </div>

                      <div class="formInput_Container col-lg-6 col-md-6 col-sm-12 col-xs-12">
                        <label for="">
                          <span style={{ color: 'red' }}>* </span>District
                        </label>
                        <DropDown
                          multi={false}
                          dropdownRenderer={false}
                          create={false}
                          onChange={this.HandleAutoSuggestValChange}
                          Type="DistrictId"
                          options={this.state.FilteredDistrictlist}
                          val={this.state.DistrictId}
                          addPlaceholder=""
                          disabled={false}
                          loading={this.state.DistrictLoader}
                          searchBy="name"
                          labelField="name"
                          valueField="id"
                          contentRenderer={false}
                          placeholder="Select"
                        />
                      </div>

                      <div className="formInput_Container col-lg-6 col-md-6 col-sm-12 col-xs-12">
                        <label htmlFor="">
                          <span style={{ color: 'red' }}>* </span>Tehsil
                        </label>
                        <DropDown
                          multi={false}
                          dropdownRenderer={false}
                          create={false}
                          onChange={this.HandleAutoSuggestValChange}
                          Type="TehsilId"
                          options={this.state.FilteredTehsillist}
                          val={this.state.TehsilId}
                          addPlaceholder=""
                          disabled={false}
                          loading={this.state.TehsilLoader}
                          searchBy="name"
                          labelField="name"
                          valueField="id"
                          contentRenderer={false}
                          placeholder="Select"
                        />
                      </div>

                      <div className="formInput_Container col-lg-6 col-md-6 col-sm-12 col-xs-12">
                        <label htmlFor="">
                          <span style={{ color: 'red' }}>* </span>Assignment
                        </label>
                        <select
                          className="form-control"
                          value={this.state.AssignmentId}
                          onChange={(event) =>
                            this.setState({ AssignmentId: +event.target.value })
                          }
                        >
                          <option>Select</option>
                          {this.state.AssignmentList.map((el) => (
                            <option key={el.id} value={el.id}>
                              {el.id}
                            </option>
                          ))}
                        </select>
                      </div>

                      <div className="formInput_Container col-lg-16 col-md-6 col-sm-12 col-xs-12">
                        <label htmlFor="">
                          <span style={{ color: 'red' }}>* </span>Patient Sample
                        </label>

                        <select
                          className="form-control"
                          value={this.state.PatientSampleId}
                          onChange={(event) =>
                            this.setState({
                              PatientSampleId: +event.target.value,
                            })
                          }
                        >
                          <option>Select</option>
                          {this.state.PatientSamples.map((el) => (
                            <option key={el.id} value={el.id}>
                              {el.id}
                            </option>
                          ))}
                        </select>
                      </div>

                      <div className="formInput_Container col-lg-16 col-md-6 col-sm-12 col-xs-12">
                        <label htmlFor="">
                          <span style={{ color: 'red' }}>* </span>Rider
                        </label>
                        <DropDown
                          multi={false}
                          dropdownRenderer={false}
                          create={false}
                          onChange={this.HandleAutoSuggestValChange}
                          Type="RiderId"
                          options={this.state.Riderlist}
                          val={this.state.RiderId}
                          addPlaceholder=""
                          disabled={false}
                          // loading={this.state.SrLoader}
                          searchBy="name"
                          labelField="name"
                          valueField="id"
                          contentRenderer={false}
                          placeholder="Select"
                        />
                      </div>

                      <div class="formInput_Container col-lg-12 col-md-12 col-sm-12 col-xs-12">
                        <label for="">Description</label>
                        <textarea
                          autocomplete="off"
                          class="form-control"
                          id="description"
                          rows="3"
                          placeholder="Enter Description"
                        ></textarea>
                      </div>

                      <div className="formInput_Container col-md-2 mt-2 ml-3">
                        <div className="text-center ">
                          <label className="CheckBox_container ">
                            <span>Deleted</span>
                            <input
                              type="checkbox"
                              onChange={(e) =>
                                this.setState({ deleted: e.target.checked })
                              }
                              checked={this.state.deleted}
                            />
                            <span className="CheckBox_checkmark"></span>
                          </label>
                        </div>
                      </div>
                      <div class="form_footer formInput_Container col-lg-12 col-md-12 col-sm-12 col-xs-12">
                        <button
                          type="submit"
                          id="Form_SaveBtn"
                          class="btn btn_style1"
                        >
                          Save
                        </button>
                        <button
                          type="button"
                          id="Form_DeleteBtn"
                          onClick={this.onDelete}
                          hidden={this.state.Id === 0}
                          class="btn btn_style2"
                        >
                          Delete
                        </button>
                        <Link to="/Dispute_List">
                          <button
                            type="button"
                            id="Form_CancelBtn"
                            class="btn btn_style3"
                          >
                            Cancel
                          </button>
                        </Link>

                        {/* Hide button for reset */}
                        <Link style={{ display: 'none' }} to="/Dispute_Add">
                          <button
                            id="Form_ResetBtn"
                            type="button"
                            class="btn initial-btn Cancel-Form-btn Form_Btn"
                          >
                            Reset
                          </button>
                        </Link>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }

  componentWillMount() {
    if (this.props.UserAuthentication.AuthToken === '') {
      this.props.history.push('/Login')
    }
  }

  componentDidMount() {
    Common.AddClassToMenueLink('MenuLink_Dispute')
    this.GetPageConfigData(() => {
      var Id = Common.GetId()
      if (Id !== 0) {
        this.SelectDisputeDetails(Id)
      }
    })
    // this.SelectAssignments()
    this.SelectPatientSamples()
  }

  GetPageConfigData = (CallBack) => {
    this.props.ShowLoader({ Isloading: true })
    var d1 = $.Deferred()
    var d2 = $.Deferred()
    var d3 = $.Deferred()
    this.SelectProvinces(() => {
      d1.resolve()
    })
    this.SelectDistricts(() => {
      d2.resolve()
    })
    this.SelectTehsil(() => {
      d3.resolve()
    })

    $.when(d1, d2, d3).done(() => {
      this.props.ShowLoader({ Isloading: false })
      CallBack()
    })
  }
  SelectProvinces = (Callback) => {
    this.setState({ ProvinceLoader: true })
    Common.Ajax(
      this.props.UserAuthentication.AuthToken,
      'GET',
      false,
      Common.APILinks.SelectAll_Province,
      {},
      (data) => {
        this.setState({
          ProvinceLoader: false,
          Provincelist: data.data,
        })
        Callback()
      },
      (error) => {
        this.setState({ ProvinceLoader: false })
        this.props.ShowAlert({ Type: 0, Msg: error })
        setTimeout(function () {
          $('#Alertmsgbtn').click()
        }, 50)
        Callback()
      },
    )
  }
  SelectDistricts = (Callback) => {
    this.setState({ DistrictLoader: true })
    Common.Ajax(
      this.props.UserAuthentication.AuthToken,
      'GET',
      false,
      Common.APILinks.SelectAll_District,
      {},
      (data) => {
        this.setState({
          DistrictLoader: false,
          Districtlist: data.data,
        })
        Callback()
      },
      (error) => {
        this.setState({ DistrictLoader: false })
        this.props.ShowAlert({ Type: 0, Msg: error })
        setTimeout(function () {
          $('#Alertmsgbtn').click()
        }, 50)
        Callback()
      },
    )
  }
  SelectTehsil = (Callback) => {
    this.setState({ TehsilLoader: true })
    Common.Ajax(
      this.props.UserAuthentication.AuthToken,
      'GET',
      false,
      Common.APILinks.SelectAll_Tehsil,
      {},
      (data) => {
        this.setState({
          TehsilLoader: false,
          Tehsillist: data.data,
        })
        Callback()
      },
      (error) => {
        this.setState({ TehsilLoader: false })
        this.props.ShowAlert({ Type: 0, Msg: error })
        setTimeout(function () {
          $('#Alertmsgbtn').click()
        }, 50)
        Callback()
      },
    )
  }
  SelectAssignments = () => {
    const Parameters = {
      provinceIdString: String(',' + this.state.ProvinceId + ','),
      districtIdString: String(',' + this.state.DistrictId + ','),
      pageNumber: 1,
      pageSize: 100,
      sortField: 'id',
      sortOrder: 'asc',
    }

    Common.Ajax(
      this.props.UserAuthentication.AuthToken,
      'GET',
      false,
      Common.APILinks.Select_AllAssignments,
      Parameters,
      (resp) => {
        if (resp.status) {
          this.setState({
            AssignmentList: resp.data,
          })
        }
      },
    )
  }
  SelectPatientSamples = () => {
    const Parameters = {
      provinceId: String(',' + this.state.ProvinceId + ','),
      districtId: String(',' + this.state.DistrictId + ','),
      pageNumber: 1,
      pageSize: 100,
      sortField: 'id',
      sortOrder: 'asc',
    }
    Common.Ajax(
      this.props.UserAuthentication.AuthToken,
      'GET',
      false,
      Common.APILinks.SelectAll_PatientSamples_Old,
      Parameters,
      (resp) => {
        if (resp.status) {
          this.setState({
            PatientSamples: resp.data,
          })
        }
      },
    )
  }
  SelectRiders = () => {
    this.setState({ RiderLoader: true })
    Common.Ajax(
      this.props.UserAuthentication.AuthToken,
      'GET',
      false,
      Common.APILinks.Select_RiderProfiles_withouDetails,
      {
        sortField: 'id',
        sortOrder: 'asc',
        provinceId: this.state.ProvinceId,
        districtId: this.state.DistrictId,
        tehsilId: this.state.TehsilId,
      },
      (data) => {
        this.setState({
          Riderlist: data.data,
          AllFetchedRider: data.data,
          RiderLoader: false,
        })
      },
    )
  }
  SelectDisputeDetails = (id) => {
    Common.Ajax(
      this.props.UserAuthentication.AuthToken,
      'Get',
      false,
      Common.BaseUrlAPI + '/api/Dispute/SelectAll',
      {},
      (resp) => {
        if (resp.status) {
          const selected = resp.data.find((item) => item.id === id)
          this.LoadDataInEditMode(selected)
        }
      },
    )
  }
  LoadDataInEditMode = (data) => {
    this.setState(
      {
        Id: data.id,
        ProvinceId: data.provinceId,
        DistrictId: data.districtId,
        TehsilId: data.tehsilId,
        PatientSampleId: data.patientSampleId,
        AssignmentId: data.assignmentId,
        RiderId: data.riderId,
        deleted: data.deleted,
      },
      () => {
        this.SelectAssignments()
        this.SelectPatientSamples()
        this.SelectRiders()
      },
    )
    $('#description').val(data.description)
  }
  ResetForm = () => {
    this.setState({
      Id: 0,
      ProvinceId: 0,
      DistrictId: 0,
      TehsilId: 0,
      HCFTypeId: 1,
    })
    $('#HCFName').val('')
    $('#Contact').val('')
    $('#Address').val('')
  }
  SubmitForm = (e) => {
    e.preventDefault()
    if (this.state.ProvinceId === 0) {
      this.props.ShowAlert({ Type: 0, Msg: 'Please select province' })
      setTimeout(function () {
        $('#Alertmsgbtn').click()
      }, 50)
      return
    }
    if (this.state.DistrictId === 0) {
      this.props.ShowAlert({ Type: 0, Msg: 'Please select district' })
      setTimeout(function () {
        $('#Alertmsgbtn').click()
      }, 50)
      return
    }
    if (this.state.TehsilId === 0) {
      this.props.ShowAlert({ Type: 0, Msg: 'Please select tehsil' })
      setTimeout(function () {
        $('#Alertmsgbtn').click()
      }, 50)
      return
    }
    this.props.ShowLoader({ Isloading: true })
    var Parameters = {
      id: this.state.Id,
      assignmentId: this.state.AssignmentId,
      patientSampleId: this.state.PatientSampleId,
      description: $('#description').val(),
      districtId: this.state.DistrictId,
      provinceId: this.state.ProvinceId,
      tehsilId: this.state.TehsilId,
      riderId: this.state.RiderId,
      deleted: this.state.deleted,
      createdBy: this.props.UserAuthentication.UserInfo.id,
      editedBy:
        this.state.Id === 0 ? 0 : this.props.UserAuthentication.UserInfo.id,
    }
    Common.Ajax(
      this.props.UserAuthentication.AuthToken,
      'Post',
      false,
      this.state.Id === 0
        ? Common.BaseUrlAPI + '/api/Dispute/Save'
        : Common.BaseUrlAPI + '/api/Dispute/Update',
      JSON.stringify(Parameters),
      (resp) => {
        if (resp.status) {
          SyncConfig(
            () => {
              if (this.state.Id !== 0) $('#Form_ResetBtn').click()
              this.ResetForm()
              this.props.ShowLoader({ Isloading: false })
              this.props.ShowAlert({ Type: 1, Msg: 'Saved successfully' })
              setTimeout(() => {
                $('#Alertmsgbtn').click()
              }, 50)
            },
            () => {
              if (this.state.Id !== 0) $('#Form_ResetBtn').click()
              this.ResetForm()
              this.props.ShowLoader({ Isloading: false })
              this.props.ShowAlert({
                Type: 0,
                Msg: 'Error in sync, please reload the page',
              })
              setTimeout(function () {
                $('#Alertmsgbtn').click()
              }, 50)
            },
          )
        } else {
          this.props.ShowLoader({ Isloading: false })
          this.props.ShowAlert({ Type: 0, Msg: resp.message })
          setTimeout(() => {
            $('#Alertmsgbtn').click()
          }, 50)
        }
      },
      (error) => {
        this.props.ShowLoader({ Isloading: false })
        this.props.ShowAlert({
          Type: 0,
          Msg: 'Something went wrong, please try again.',
        })
        setTimeout(() => {
          $('#Alertmsgbtn').click()
        }, 50)
      },
    )
  }
  onDelete = () => {
    this.setState(
      {
        alertModalData: {
          title: 'Delete Dispute?',
          message: 'Are you sure you want to delete this record.',
          First_Callback: () => {
            $('#Generic-modal-CloseBtn').click()
            this.DeleteRecord()
          },
          Second_Callback: () => {
            $('#Generic-modal-CloseBtn').click()
          },
          type: 1,
        },
      },
      () => {
        $('#Show_ArletModal').click()
      },
    )
  }
  DeleteRecord = () => {
    this.props.ShowLoader({ Isloading: true })
    Common.Ajax(
      this.props.UserAuthentication.AuthToken,
      'Get',
      false,
      Common.BaseUrlAPI + '/api/Dispute/Delete',
      { id: this.state.Id },
      (Result) => {
        if (Result.status) {
          SyncConfig(
            () => {
              $('#Form_CancelBtn').click()
              this.props.ShowLoader({ Isloading: false })
              this.props.ShowAlert({ Type: 1, Msg: 'Deleted Successfully.' })
              setTimeout(function () {
                $('#Alertmsgbtn').click()
              }, 50)
            },
            () => {
              this.props.ShowLoader({ Isloading: false })
              this.props.ShowAlert({
                Type: 0,
                Msg: 'Error in sync, please reload the page',
              })
              setTimeout(function () {
                $('#Alertmsgbtn').click()
              }, 50)
            },
          )
        } else {
          this.props.ShowLoader({ Isloading: false })
          this.props.ShowAlert({ Type: 0, Msg: Result.message })
          setTimeout(function () {
            $('#Alertmsgbtn').click()
          }, 50)
        }
      },
      (error) => {
        this.props.ShowLoader({ Isloading: false })
        this.props.ShowAlert({
          Type: 0,
          Msg: 'Something went wrong, please try again.',
        })
        setTimeout(function () {
          $('#Alertmsgbtn').click()
        }, 50)
      },
    )
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Dispute_Add)
